import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { bootstrapSso, showSsoError } from './sso';
import { API_URL } from './apiConfig';
import { isToolsPortal } from './tools/config';
import { registerToolsWorker } from './tools/pwa';
import reportWebVitals from './reportWebVitals';

async function start() {
  if (isToolsPortal) registerToolsWorker();
  if (!await bootstrapSso(isToolsPortal ? 'tools' : 'f1', 'token', API_URL)) return;
  showSsoError();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
}
start();
